import React, {Suspense, lazy, useEffect} from 'react'
import {HashRouter as Router, Routes, Route} from 'react-router-dom'
import {HelmetProvider} from 'react-helmet-async'
import {AppThemeProvider} from './hooks/useAppTheme'
import ErrorBoundary from './components/ErrorBoundary'
import {registerServiceWorker} from './utils'
import './App.css'

// Lazy load components for better performance
const HomePage = lazy(() => import('./pages/HomePage'))
const AboutPage = lazy(() => import('./pages/AboutPage'))
const ServicesPage = lazy(() => import('./pages/ServicesPage'))
const ContactPage = lazy(() => import('./pages/ContactPage'))
const PrivacyPage = lazy(() => import('./pages/PrivacyPage'))
const TermsPage = lazy(() => import('./pages/TermsPage'))
const AdminLogin = lazy(() => import('./pages/AdminLogin'))
const AdminDashboard = lazy(() => import('./pages/AdminDashboard'))

// Loading component
const LoadingSpinner = () => (
  <div className="min-h-screen bg-black flex items-center justify-center">
    <div className="text-center">
      <div className="w-16 h-16 bg-gradient-brand rounded-full mx-auto mb-4 animate-pulse"></div>
      <p className="text-white font-medium">Loading the rebellion...</p>
    </div>
  </div>
)

function App() {
  // Register service worker for PWA functionality
  useEffect(() => {
    registerServiceWorker();
  }, []);

  return (
    <HelmetProvider>
      <AppThemeProvider>
        <ErrorBoundary>
          <Router>
            <div className="App min-h-screen transition-colors duration-300">
              <Suspense fallback={<LoadingSpinner />}>
                <Routes>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/about" element={<AboutPage />} />
                  <Route path="/services" element={<ServicesPage />} />
                  <Route path="/contact" element={<ContactPage />} />
                  <Route path="/privacy" element={<PrivacyPage />} />
                  <Route path="/terms" element={<TermsPage />} />
                  <Route path="/admin/login" element={<AdminLogin />} />
                  <Route path="/admin/dashboard" element={<AdminDashboard />} />
                  {/* 404 fallback */}
                  <Route path="*" element={<HomePage />} />
                </Routes>
              </Suspense>
            </div>
          </Router>
        </ErrorBoundary>
      </AppThemeProvider>
    </HelmetProvider>
  )
}

export default App